<template>
  <footer>
    <div id="footer" class="">
      <div class="footer-top">
        <div class="container">
          <div class="row">
            <div v-if="footerAbout" class="col-lg-3 col-md-6 footer-info">
              <div class="logo">
                <h1>
                  <a href="/"><span> {{ footerAbout.title }}</span></a>
                </h1>
              </div>
              <p>
                {{ footerAbout.short_description }} ...<a
                  :href="`${baseUrl}about`"
                  >আরো দেখুন</a
                >
              </p>
            </div>

            <div class="col-lg-6 col-md-12 footer-links">
              <h4>গুরুত্বপূর্ণ লিঙ্ক</h4>
              <div class="row">
                <div class="col-lg-6">
                  <ul>
                    <li>
                      <i class="fa fa-angle-right"></i>
                      <a :href="`${baseUrl}about`">আমাদের সম্পর্কে</a>
                    </li>
                    <li>
                      <i class="fa fa-angle-right"></i>
                      <a :href="`${baseUrl}contact`">যোগাযোগ</a>
                    </li>
                    <li>
                      <i class="fa fa-angle-right"></i>
                      <a :href="`${baseUrl}privacy-policy`">গোপনীয়তা নীতি</a>
                    </li>
                    <li>
                      <i class="fa fa-angle-right"></i>
                      <router-link :to="{name: 'CaQuiz'}">কারেন্ট অ্যাফেয়ার্স কুইজ</router-link>
                    </li>
                  </ul>
                </div>
                <div class="col-lg-6">
                  <ul>
                    <li v-for="(item, index) in homeSections" v-bind:key="index">
                      <i class="fa fa-angle-right"></i>
                      <a :href="`${baseUrl}section/${item.id}`">{{ item.title }}</a>
                    </li>
                    <!-- <li>
                      <i class="fa fa-angle-right"></i>
                      <a :href="`${baseUrl}books/Bestsellers`">বেস্টসেলার</a>
                    </li>
                    <li>
                      <i class="fa fa-angle-right"></i>
                      <a :href="`${baseUrl}books/New Releases`"
                        >সদ্য প্রকাশিত</a
                      >
                    </li> -->
                  </ul>
                </div>
              </div>
            </div>

            <div class="col-lg-3 col-md-6 footer-contact">
              <h4>যোগাযোগ</h4>
              <div style="padding-top: 10px">
                <div v-html="`${contact[0].description}`"></div>
                Phone : {{ contact[0].short_description }}<br />
              </div>

              <div class="social-links mt-3">
                <span v-for="(item, key) in social" v-bind:key="key">
                  <a
                    :href="`${item.short_description}`"
                    :class="`${item.title}`"
                    target="_blank"
                    ><i :class="`fa fa-${item.title}`"></i
                  ></a>
                </span>
              </div>

              <!-- <div class="visit mt-3">
                <div>Today Visit : {{ today_visitor }}</div>
                <div>Total Visit : {{ total_visitor }}</div>
              </div> -->
            </div>
          </div>
        </div>
      </div>

      <div class="copyright-row">
        <div class="row d-flex justify-content-center">
          <div class="copyright">
            Copyright © {{ new Date().getFullYear() }}
            <a href="https://professorsprokashon.com">Professor's Prokashon</a>. All Rights
            Reserved.
          </div>

          <!-- <div class="payment-icons">
            <img src="/assets/img/icons/bkash.svg" alt="" />
            <img src="/assets/img/icons/roket.svg" alt="" />
            <img src="/assets/img/icons/amex.svg" alt="" />
            <img src="/assets/img/icons/master.svg" alt="" />
            <img src="/assets/img/icons/visa.svg" alt="" />
            <img src="/assets/img/icons/dbbl.svg" alt="" />
          </div> -->
        </div>
      </div>
    </div>
    <a href="javascript:;" class="back-to-top"
      > <i class="fa fa-arrow-up"></i>
    </a>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      today_visitor: "",
      total_visitor: "",
      footerAbout: null,
      homeSections: [],
      contact: [
        {
          description: "Loading...",
          title: "Loading...",
          custom_field: null,
        },
      ],
      social: [],
    };
  },
  methods: {
    getFooterAbout() {
      fetch(this.APIURL + "cms-resources/Footer-About")
        .then((response) => response.json())
        .then((json) => (this.footerAbout = json.data[0]));
    },
    getContact() {
      fetch(this.APIURL + "cms-resources/Contact-Us")
        .then((response) => response.json())
        .then((json) => (this.contact = json.data));
    },
    getSocial() {
      fetch(this.APIURL + "cms-resources/Social-Links")
        .then((response) => response.json())
        .then((json) => (this.social = json.data));
    },
    getVisitors() {
      fetch(this.APIURL + "visitor-resources/count")
        .then((response) => response.json())
        .then((json) => {
          (this.today_visitor = json.today_visitor),
            (this.total_visitor = json.total_visitor);
        });
    },
    postVisitors() {
      let formData = new FormData();
      formData.append("count", 1);

      fetch(this.APIURL + "visitor-resources/count", {
        method: "POST",
        body: formData,
      })
        .then((response) => response.json())
        .then((json) => console.log(json));
    },
    getHomeSections() {
      this.$http
        .get("home-sections-name")
        .then((response) => {
          this.homeSections = response.data;
          console.log(response.data);
        })
        .catch((e) => {
          this.homeSections = [];
        });
    },
  },
  mounted() {
    this.getFooterAbout();
    this.getContact();
    this.getSocial();
    this.getVisitors();
    this.postVisitors();
    this.getHomeSections();
  },
  updated() {
    $(".loader").fadeOut("slow");
  },
};
</script>
